const r = (e) => ({
  html: e.properties?.content?.markup || ""
});
export {
  r as richtextDeliveryApiParser
};
